export default "__VITE_ASSET__DZEdZnKC__"